/**
 * Config
 *
 * Module that keeps the state of the Search application's configuration.
 * This allows for the Search application to be controlled independant of
 * the overall OT Common application.
 *
 * @return {object}
 */

OT.createNS('OT.Search.Config');

OT.Search.Config = (function() {
    'use strict';

    // Default configuration for all OT apps

    var config = {},
        defaultConfig = {
            enableAllLogging: true,
            enableErrorLogging: true,
            enableJSRendering: true,
            enablePageLoadLogging: true,
            enableInteractionLogging: true,
            resultRetries: 3
        };

    _.each(defaultConfig, function(v, k) {
        config[k.toLowerCase()] = typeof v !== 'boolean' && typeof v !== 'number' ? v.toLowerCase() : v;
    });


    var getAll = function() {
        return config;
    };

    var getConfig = function(key) {
        if(typeof key === 'string') {
            return config[key.toLowerCase()];
        }

        var allTrue = true;

        if(key instanceof Array) {
            _.each(key, function(k) {
                if(!getConfig(k)) {
                    allTrue = false;
                }
            });
        } else {
            _.each(key, function(v, k) {
                if(!getConfig(k)) {
                    allTrue = false;
                }
            });
        }

        return allTrue;
    };

    var setConfig = function(key, val) {
        if(typeof key === 'object') {
            var obj = {};

            _.each(key, function(v, k) {
                obj[k.toLowerCase()] = v;
            });

            _.extend(config, obj);
        } else {
            config[key.toLowerCase()] = val;
        }
    };

    return {
        get: getConfig,
        getAll: getAll,
        set: setConfig
    };

})();